// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__dikP9","label":"CategoryService_label___SjCE","location":"CategoryService_location__37aNJ"};